<!-- 弹窗组件 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1" class="head-text">样式设置</MenuItem>
                <MenuItem name="2" class="head-text">内容设置</MenuItem>
                <MenuItem name="3" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <div class="form-title mt-24">样式设置</div>
                        <FormItem label="弹框样式">
                            <RadioGroup v-model="newFormData.content.styleValue">
                                <Radio class="mr-24" label="1">弹框</Radio>
                                <Radio class="mr-24" label="2">非全屏广告</Radio>
                                <Radio class="mr-24" label="3">全屏广告</Radio>
                            </RadioGroup>
                        </FormItem>
                        <div class="form-title mt-24">按钮设置</div>
                        <FormItem label="按钮设置">
                            <RadioGroup v-model="newFormData.content.btnValue">
                                <Radio class="mr-24" label="1">无</Radio>
                                <Radio class="mr-24" label="2">单按钮</Radio>
                                <Radio class="mr-24" label="3">双按钮</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem v-if="newFormData.content.styleValue == 2" label="取消方式">
                            <RadioGroup v-model="newFormData.content.cancelValue">
                                <Radio class="mr-24" label="1">按钮</Radio>
                                <Radio class="mr-24" label="2">倒计时</Radio>
                            </RadioGroup>
                            <RadioGroup v-if="newFormData.content.cancelValue == 1" v-model="newFormData.content.cancelPositionValue">
                                <Radio class="mr-24" label="1">右上</Radio>
                                <Radio class="mr-24" label="2">正下</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem v-if=" newFormData.content.styleValue == 3 || newFormData.content.cancelValue == 2" label="倒计时">
                            <InputNumber v-model="newFormData.content.countdown" :max="60" :min="0" placeholder="倒计时" 
                                :formatter="value => `${value}s`"
                                :parser="value => value.replace('s', '')"
                                style="width: 100%;"></InputNumber>
                        </FormItem>
                        <FormItem v-if="newFormData.content.styleValue == 3 || newFormData.content.cancelValue == 2" label="按钮背景">
                            <ColorPicker v-model="newFormData.content.countdown_bg_color"/>
                        </FormItem>
                        <FormItem v-if="newFormData.content.styleValue == 3 || newFormData.content.cancelValue == 2" label="透明度">
                            <Input v-model="newFormData.content.countdown_opacity" placeholder="透明度">
                                <span slot="append">%</span>
                            </Input>
                        </FormItem>
                        <FormItem v-if="newFormData.content.styleValue == 3 || newFormData.content.cancelValue == 2" label="文字颜色">
                            <ColorPicker v-model="newFormData.content.countdown_text_color"/>
                        </FormItem>
                        <div class="form-title mt-24">背景设置</div>
                        <FormItem label="背景颜色"><ColorPicker v-model="newFormData.content.bg_color"/></FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <div v-if="popData.content.styleValue == 1">
                            <div class="form-title mt-24">标题设置</div>
                            <FormItem label="弹框标题"><Input v-model="newFormData.content.title" placeholder="弹框标题"></Input></FormItem>
                            <FormItem label="标题大小"><Input v-model="newFormData.content.title_size" placeholder="标题大小"></Input></FormItem>
                            <FormItem label="标题颜色"><ColorPicker v-model="newFormData.content.title_color"/></FormItem>
                            <div class="form-title mt-24">内容设置</div>
                            <FormItem label="弹框内容"><Input v-model="newFormData.content.text" type="textarea" placeholder="弹框内容"></Input></FormItem>
                            <FormItem label="文字位置">
                                <RadioGroup v-model="newFormData.content.text_position" type="button">
                                    <Radio label="left" ><Icon type="md-menu"/></Radio>
                                    <Radio label="center" ><Icon type="md-funnel"/></Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem label="内容大小"><Input v-model="newFormData.content.text_size" placeholder="内容大小"></Input></FormItem>
                            <FormItem label="内容颜色"><ColorPicker v-model="newFormData.content.text_color"/></FormItem>
                        </div>
                        <div v-if="popData.content.styleValue == 2 || popData.content.styleValue == 3">
                            <div class="form-title mt-24">图片上传</div>
                            <FormItem label="图片"></FormItem>
                            <div class="form-div">
                                <div class="banner-box" @click="openModal">
                                    <img class="del-icon-style" src="@/assets/homeset/del.png" @click.stop="delPopImg"/>
                                    <img v-if="popData.content.picview" :src="popData.content.picview"/>
                                    <Icon class="absolute-icon" type="md-add"/>
                                </div>
                            </div>
                        </div>
                        <div v-if="popData.content.btnValue != 1">
                            <div class="form-title mt-24">按钮设置</div>
                            <div class="view1">
                                <div class="view1" v-if="popData.content.btnValue == 2 || popData.content.btnValue == 3">
                                    <FormItem label="按钮文字">
                                        <Input v-model="newFormData.content.btn_text" placeholder="按钮文字"></Input>
                                    </FormItem>
                                    <FormItem label="按钮背景">
                                        <ColorPicker v-model="newFormData.content.btn_bg_color"/>
                                    </FormItem>
                                    <FormItem label="按钮边框">
                                        <ColorPicker v-model="newFormData.content.btn_border_color"/>
                                    </FormItem>
                                    <Select class="mt-6" v-model="newFormData.content.action_id" filterable placeholder="跳转动作">
                                        <Option v-for="item in actionList2" :value="item.id" :key="item.id" >{{ item.name }}</Option >
                                    </Select>
                                    <Input class="mt-6" v-if="newFormData.content.action_id == 1" v-model="newFormData.content.link_name" placeholder="请输入外部链接（http/https）"></Input>
                                    <Select class="mt-6" v-if="newFormData.content.action_id == 2" v-model="newFormData.content.link_id" filterable placeholder="跳转链接">
                                        <Option v-for="item in linkList" :value="item.id" :key="item.id">{{ item.title }}</Option>
                                    </Select>
                                </div>
                                <div class="div1" v-if="popData.content.btnValue == 3">
                                    <FormItem label="按钮文字">
                                        <Input v-model="newFormData.content.btn_text2" placeholder="按钮文字"></Input>
                                    </FormItem>
                                    <FormItem label="按钮背景">
                                        <ColorPicker v-model="newFormData.content.btn_bg_color2"/>
                                    </FormItem>
                                    <FormItem label="按钮边框">
                                        <ColorPicker v-model="newFormData.content.btn_border_color2"/>
                                    </FormItem>
                                    <Select class="mt-6" v-model="newFormData.content.action_id2" filterable placeholder="跳转动作">
                                        <Option v-for="item in actionList2" :value="item.id" :key="item.id">{{ item.name }}</Option>
                                    </Select>
                                    <Input class="mt-6" v-if="newFormData.content.action_id2 == 1" v-model="newFormData.content.link_name2" placeholder="请输入外部链接（http/https）"></Input>
                                    <Select class="mt-6" v-if="newFormData.content.action_id2 == 2" v-model="newFormData.content.link_id2" filterable placeholder="跳转链接">
                                        <Option v-for="item in linkList" :value="item.id" :key="item.id">{{ item.title }}</Option>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div v-if="name_id == 3">
                    <Form :model="newFormData" label-position="left" :label-width="80" >
                        <div class="form-title">组件间距</div>
                        <FormItem label="上下间距">
                            <Slider class="w300" v-model="newFormData.content.marginData.top"></Slider>
                        </FormItem>
                        <FormItem label="左右间距">
                            <Slider class="w300" v-model="newFormData.content.marginData.left"></Slider>
                        </FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角">
                            <Slider class="w300" v-model=" newFormData.content.marginData.topRadius"></Slider>
                        </FormItem>
                        <FormItem label="下圆角">
                            <Slider class="w300" v-model=" newFormData.content.marginData.bottomRadius"></Slider>
                        </FormItem>
                        <div class="form-title" v-if="popData.content.btnValue != 1">按钮设置</div>
                        <FormItem v-if="popData.content.btnValue != 1" label="左右边距">
                            <Slider class="w300" v-model="newFormData.content.btnMargin"></Slider>
                        </FormItem>
                        <FormItem v-if="popData.content.btnValue != 1" label="圆角">
                            <Slider class="w300" v-model="newFormData.content.btnRadius"></Slider>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        newFormData: {
            type: Object,
            default: {},
        },
        popData: {
            type: Object,
            default: {},
        },
        linkList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            actionList2: [],
        };
    },
    mounted() {
        if (this.diy_id == 1) {
            this.actionList2 = [
                { id: 1, name: "跳转外部链接" },
                { id: 2, name: "跳转页面" },
                { id: 3, name: "扫一扫" },
                { id: 4, name: "关闭弹窗" },
            ];
        } else {
            this.actionList2 = [
                { id: 1, name: "跳转外部链接" },
                { id: 3, name: "扫一扫" },
                { id: 4, name: "关闭弹窗" },
            ];
        }
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.popData.content.picview = param1[i];
            }
            this.$Message.destroy();
            return
        },
        openModal() {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        delPopImg() {
            this.popData.content.picview = "";
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.banner-box {
    margin: 12px 0;
    width: 100%;
    height: 130px;
    display: flex;
    justify-content: center;
    position: relative;
    border: 1px solid #c0c4cc;
}
.banner-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.del-icon-style {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 99;
    width: 26px !important;
    height: 26px !important;
    cursor: pointer;
}
.absolute-icon {
    position: absolute;
    font-size: 50px;
    cursor: pointer;
    color: #c0c4cc;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
}
.div1 {
    padding: 12px;
    margin: 12px 0 0 0;
    border: 1px solid #ccc;
}
.form-div {
    padding: 12px;
    border: 1px solid #c0c4cc; 
}
.view1 {
    padding: 12px; 
    border: 1px solid #ccc;
}
.mt-6 {
    margin: 6px 0 0 0;
}
</style>